var angular = require('angular');
var _module = require('../module');
var sizes = [
    {
        name: '',
        breakPoint: 0,
        type: 'gt'
    },
    {
        name: 'xs',
        breakPoint: 600,
        type: 'lt'
    },
    {
        name: 'gt-xs',
        breakPoint: 600,
        type: 'gt'
    },
    {
        name: 'sm',
        breakPoint: [600, 960],
        type: 'bt'
    },
    {
        name: 'gt-sm',
        breakPoint: 960,
        type: 'gt'
    },
    {
        name: 'md',
        breakPoint: [960, 1280],
        type: 'bt'
    },
    {
        name: 'gt-md',
        breakPoint: 1280,
        type: 'bt'
    },
    {
        name: 'lg',
        breakPoint: [1280, 1920],
        type: 'bt'
    },
    {
        name: 'gt-lg',
        breakPoint: 1920,
        type: 'bt'
    },
    {
        name: 'xl',
        breakPoint: 1920,
        type: 'gt'
    }
];

function hump(str) {
    if(str === '') return str;

    return str.split('-').map(function humpMap(s) {
        return s.charAt(0).toUpperCase() + s.slice(1);
    })
    .join('');
}

sizes.forEach(function sizesLoop(size) {
    _module.directive('windowHeight' + hump(size.name), [
        '$log',
        '$window',
        '$timeout',

        function windowHeight($log, $window, $timeout) {
            return {
                restrict: 'A',
                link: function windowHeightLink($scope, elem, attrs) {
                    var windowWidth = 0;
                    var offsetAmt = 0;

                    $timeout(windowHeightWindowResize, 50);
                    angular.element(window).on('resize', windowHeightWindowResize);

                    // $watch Functions
                    $scope.$watch(attrs.windowHeightOffset, function windowHeightOffset(value) {
                        if(value) {
                            offsetAmt = parseInt(value);

                            console.log(offsetAmt);

                            changeHeight();
                        }
                    });

                    // Functions
                    function windowHeightWindowResize() {
                        var ww = $window.innerWidth;

                        if(
                            (size.type === 'gt' && ww >= size.breakPoint) ||
                            (size.type === 'lt' && ww < size.breakPoint) ||
                            (size.type === 'bt' && ww >= size.breakPoint[0] && ww < size.breakPoint[1])
                        ) {
                            if(ww > (windowWidth + 20) || ww < (windowWidth - 20)) changeHeight();
                        } else {
                            elem.css((attrs.windowHeight == 'minHeight' ? 'minHeight' : 'height'), null);
                        }

                        windowWidth = ww;
                    }

                    function changeHeight() {
                        elem.css((attrs.windowHeight == 'minHeight' ? 'minHeight' : 'height'), ($window.innerHeight + offsetAmt) + 'px');
                    }
                }
            };
        }
    ]);
});
